import { ConvDivComboBoxModel } from '../conv-div-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * カテゴリ変換区分リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetConvDivListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetConvDivListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: ConvDivComboBoxModel;
  private categoryDiv: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetConvDivListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryDiv: this.categoryDiv
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {ConvDivboBoxModel} model
   * @param {string} categoryDiv
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetConvDivListService
   */
  execute(model: ConvDivComboBoxModel, categoryDiv: string, successFunc: Function = null) {
    this.model = model;
    this.categoryDiv = categoryDiv;
    this.successFunc = successFunc;
    this.send('KYMW02getConvDivList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingCodeListService
   */
  success(data: any) {
    this.model.updateConvDivList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
